var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartner3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4734_2457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.388878H74V71.5645H0V0.388878Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4734_2457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5687 41.3895V42.3807C30.5687 43.5749 29.7767 44.6355 28.6002 45.0151L16.0505 49.0771C12.5211 50.2198 10.1436 53.4004 10.1436 56.9828V70.5215",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4316 41.4062V42.3807C43.4316 43.5749 44.2237 44.6355 45.4002 45.015L57.9498 49.0771C61.4793 50.2198 63.8568 53.4004 63.8568 56.9828V70.5215",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3643 20.1992V8.38296C20.3643 4.54421 23.5997 1.43222 27.5908 1.43222H46.4098C50.4009 1.43222 53.6364 4.54421 53.6364 8.38296V20.1992",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6357 18.1127H54.7755C56.5533 18.1127 57.9942 19.4988 57.9942 21.2087C57.9942 22.9184 56.5533 24.3047 54.7755 24.3047H53.6357",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3643 18.1127H19.2246C17.4468 18.1127 16.0059 19.4988 16.0059 21.2087C16.0059 22.9184 17.4468 24.3047 19.2246 24.3047H20.3643",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5755 32.5297C20.7929 30.6547 20.3623 28.6092 20.3623 26.4737V18.1135C23.6793 18.1229 28.663 17.7192 34.1736 15.5845C36.7441 14.5888 38.9031 13.4201 40.6538 12.3028C41.0326 12.0612 41.5389 12.1464 41.8174 12.4917C42.6982 13.584 44.177 15.0959 46.4198 16.2931C49.439 17.9044 52.2638 18.1033 53.6344 18.1135V26.6473C53.6344 35.5034 46.1545 42.6789 36.9396 42.6483C31.7691 42.6311 27.1716 40.3148 24.1376 36.7181",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5869 21.2911V23.873",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4111 21.2911V23.873",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6543 33.8923C34.9416 34.0881 35.8545 34.6573 37.1453 34.6128C38.2619 34.5743 39.045 34.0977 39.3456 33.8923",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7146 45.1169L37.5541 52.9659C37.3282 53.1832 36.9622 53.1832 36.7363 52.9659L28.5029 45.047",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.023 65.7676H16.8082C16.3139 65.7676 15.9131 65.3821 15.9131 64.9067V60.6634C15.9131 58.5238 17.7164 56.7892 19.941 56.7892C22.1657 56.7892 23.969 58.5238 23.969 60.6634V64.9067C23.969 65.3821 23.5682 65.7676 23.0739 65.7676H21.8591",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1484 59.4658C49.8727 57.8893 51.5125 56.7892 53.4196 56.7892C55.9973 56.7892 58.087 58.799 58.087 61.2784C58.087 63.7577 55.9973 65.7676 53.4196 65.7676C51.9457 65.7676 50.6312 65.1103 49.7758 64.0838",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4189 56.7891C53.8275 55.907 54.4139 54.3373 54.4338 52.3078C54.4551 50.1632 53.834 48.5085 53.4189 47.6123",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9409 56.7891C19.5567 55.9236 19.0728 54.537 19.0043 52.7806C18.9184 50.58 19.526 48.8615 19.9409 47.9242",
    stroke: "#01A5AF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.083 58.0101C38.083 58.5859 37.5977 59.0527 36.999 59.0527C36.4004 59.0527 35.915 58.5859 35.915 58.0101C35.915 57.4343 36.4004 56.9675 36.999 56.9675C37.5977 56.9675 38.083 57.4343 38.083 58.0101Z",
    fill: "#01A5AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.083 64.266C38.083 64.8418 37.5977 65.3086 36.999 65.3086C36.4004 65.3086 35.915 64.8418 35.915 64.266C35.915 63.6902 36.4004 63.2234 36.999 63.2234C37.5977 63.2234 38.083 63.6902 38.083 64.266Z",
    fill: "#01A5AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.083 70.5218C38.083 71.0976 37.5977 71.5645 36.999 71.5645C36.4004 71.5645 35.915 71.0976 35.915 70.5218C35.915 69.946 36.4004 69.4792 36.999 69.4792C37.5977 69.4792 38.083 69.946 38.083 70.5218Z",
    fill: "#01A5AF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner3);
export default __webpack_public_path__ + "static/media/partner-3.ef23acbe5eb170626fe76b25d362c570.svg";
export { ForwardRef as ReactComponent };